import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NiceSelectModule } from "ng-nice-select";
import { NgxPaginationModule } from 'ngx-pagination';
import { FilePondModule, registerPlugin } from 'ngx-filepond';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { ExpensesRoutingModule } from '@teem/expenses-module/expenses-routing.module';
import { ExpensesComponent } from '@teem/expenses-module/expenses.component';
import { ExpensesTableComponent } from '@teem/expenses-module/components/expenses-table/expenses-table.component';
import { OtherExpensesTableComponent } from '@teem/expenses-module/components/other-expenses-table/other-expenses-table.component';
import { AddExpenseModalComponent } from './modals/add-expense-modal/add-expense-modal.component';
import { AddOtherExpenseModalComponent } from './modals/add-other-expense-modal/add-other-expense-modal.component';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
import { EditExpenseModalComponent } from './modals/edit-expense-modal/edit-expense-modal.component';

registerPlugin( 
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);
@NgModule({
  declarations: [
    ExpensesComponent,
    ExpensesTableComponent,
    OtherExpensesTableComponent,
    AddExpenseModalComponent,
    AddOtherExpenseModalComponent,
    EditExpenseModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    NgxPaginationModule,
    FilePondModule, 
    ExpensesRoutingModule
  ]
})
export class ExpensesModule { }
